import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { FileService, NAMESPACE_ENUM } from '../file-list/file-list.service';

@Component({
  selector: 'sm-opinion-block',
  imports: [CommonModule, TranslateModule, ButtonModule],
  templateUrl: './opinion-block.component.html',
})
export class OpinionBlockComponent {
  private readonly fileService = inject(FileService);
  @Input() avis?: string;
  @Input() user?: string;
  @Input() createdAt?: string;
  @Input() alfrescoId?: string;
  @Input() namespace?: NAMESPACE_ENUM;

  onDownload() {
    if (this.alfrescoId) {
      this.fileService.download(
        {
          alfresco_id: this.alfrescoId,
          filename: `avis_${this.user}_${this.createdAt}`,
          extension: 'pdf',
        },
        this.namespace
      );
    }
  }
}
